/**
 * Created by RaoMeng on 2018/11/15
 * Desc: 会议签到
 */

export default function MeetingBean() {
    this.meetId = 0
    this.title = ''
    this.meetStatus = ''
    this.meetStatusCode = 0
    this.meetDetail = ''
    this.createTime = ''
    this.startTime = ''
    this.endTime = ''
    this.remainTime = ''
    this.address = ''
    this.sponsor = ''
    this.sponsorId = 0
    this.signStatus = ''
    this.signStatusCode=0
    this.remarks = ''

}